import React from "react";
import { Card, Row, Col, Typography } from "antd";
import ReactECharts from "echarts-for-react";
import { useSelector } from "react-redux";

const { Title } = Typography;

const pieColors = ["#5470C6", "#91CC75", "#FAC858", "#EE6666"];
const sourceLabels = ["EB", "Wind", "IEX", "Solar"];

const getDonutOption = (title) => ({
  title: {
    text: title,
    left: "center",
    top: 0,
    textStyle: {
      fontSize: 14,
      fontWeight: 600
    }
  },
  tooltip: {
    trigger: "item"
  },
  legend: {
    bottom: 0,
    left: "center"
  },
  series: [
    {
      name: title,
      type: "pie",
      radius: ["50%", "70%"],
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 8,
        borderColor: "#fff",
        borderWidth: 2
      },
      label: {
        show: false
      },
      emphasis: {
        label: {
          show: true,
          fontSize: "14",
          fontWeight: "bold"
        }
      },
      labelLine: {
        show: false
      },
      data: [
        { value: 40, name: "EB" },
        { value: 25, name: "Wind" },
        { value: 20, name: "IEX" },
        { value: 15, name: "Solar" }
      ]
    }
  ],
  color: pieColors
});

const EnergyDashboard = () => {
    const mode = useSelector((state) => state.darkMode);
  const color = useSelector((state) => state.ThemeChange);
  console.log(color);
  const { isdarkMode } = mode;
  return (
    <div className="p-4 w-full">
      <Row gutter={[16, 16]}>
        {/* Donut Charts */}
        {["Consumption By Source (Yesterday)", "Consumption By Source (MTD)", "Costing By Source (Yesterday)"].map(
          (title, index) => (
            <Col xs={24} md={8} key={index}>
              <Card bordered className="bg-blue-50" style={{ borderRadius: 12 }}
               title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                {title}
              </span>
            }>
                <ReactECharts option={getDonutOption(title)} style={{ height: 220 }} />
              </Card>
            </Col>
          )
        )}
      </Row>

      <div className="mt-4 flex flex-wrap justify-between ">
        {/* Renewables */}
        <div className=" w-[32%]" >
          <Card className="" bordered style={{ borderRadius: 12 }}
           title={
              <span className={isdarkMode ? "text-white" : "text-black"}>
                Renewables
              </span>
            }
            >
               <Card className=" mb-3 w-full flex justify-center items-center bg-blue-50"  bordered style={{ borderRadius: 8 }}>
                    <Title level={5} style={{ margin: 0, color: "#000" }}>
                     Today:
                    </Title>
                    <p  className="text-center" style={{ marginBottom: 0,color: "#1890ff" }}>50%</p>
                  </Card>
               <Card className=" w-full flex justify-center items-center bg-blue-50"  bordered style={{ borderRadius: 8 }}>
                    <Title level={5} style={{ margin: 0, color: "#000" }}>
                     Month (To Date):
                    </Title>
                    <p className="text-center" style={{ color: "#1890ff" }}>47%</p>
                  </Card>
          </Card>
        </div >

<div className="flex flex-col w-2/3">
        {/* Yesterday Consumption */}
    
          <Card bordered style={{ borderRadius: 12 }}>
            <Title level={5}>Yesterday Consumption</Title>
            <div className="flex justify-between">
              {["C1", "C2", "C4", "C5"].map((c) => (
                  <Card className="mx-3 w-44 bg-blue-50"  bordered style={{ borderRadius: 8 }}>
                    <p style={{ marginBottom: 0 }}>{c}</p>
                    <Title level={5} style={{ margin: 0, color: "#1890ff" }}>
                      40,000
                    </Title>
                  </Card>
              ))}
            </div>
                <div className="mt-4"  style={{ borderRadius: 12 }}>
            <Title level={5}>MTD Consumption</Title>
            <div className="flex justify-between">
              {["C1", "C2", "C4", "C5"].map((c) => (
                  <Card className="mx-3 w-44 bg-blue-50"  bordered style={{ borderRadius: 8 }}>
                    <p style={{ marginBottom: 0 }}>{c}</p>
                    <Title level={5} style={{ margin: 0, color: "#1890ff" }}>
                      40,000
                    </Title>
                  </Card>
              ))}
            </div>
          </div>
          </Card>

</div>
      </div>
    </div>
  );
};

export default EnergyDashboard;
